<template>
<div>
<v-progress-circular v-if="loading" indeterminate v-bind:size="70" v-bind:width="7" class="purple--text"></v-progress-circular>
<v-layout column>
<v-flex xs12>
    <v-toolbar class="indigo" dark>
        <v-toolbar-title>Asche steht noch aus</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch v-if="currentUser.group === 'admin'" class="mt-5 mr-5" :label="switchSearch ? 'Nach Namen der Verstorbenen filtern' : 'Nach Mitarbeiter filtern'" v-model="switchSearch"></v-switch>
        <v-btn-toggle v-if="!switchSearch" class="pa-0 ma-0" v-model="userSelected">
            <v-btn :value="user.name" v-for="user in usersList" :key="user.id" color="primary">{{user.name}}</v-btn>
        </v-btn-toggle>
        <v-text-field v-else class="mt-5 ml-5" style="max-width:200px" placeholder="Nach Namen filtern" v-model="search" prepend-icon="mdi-magnify"></v-text-field>
        
      </v-toolbar>
      <v-container fluid grid-list-xl style="font-size: 16px">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg6 xl4 v-for="defunt in defuntsFilter" :key="defunt.id_defunt">
            <v-card hover @click.stop.native="defSelected(defunt.id_defunt)" style="min-height:400px">
                <v-card-title style="font-size: 18px" :class="defunt.sexe=='Féminin' ? 'pink white--text' : 'blue white--text'">
                    <span v-text="defunt.titre + ' ' + defunt.prenom + ' ' + defunt.nom" style="font-weight: 500"></span>
                    <v-spacer></v-spacer>
                    <v-chip v-if="currentUser.group === 'admin'" color="primary lighten-4" outlined pill>
                        <v-icon left>mdi-account-outline</v-icon>
                        {{defunt.createdByName}}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <span>{{defunt.num}}</span>
                </v-card-title>
                <v-container fluid>
                    <v-layout row>
                        <v-flex xs10>
                            <div>{{defunt.inhCendresQuand}}</div>
                            <div v-if="defunt.inhCendresLieu!=''">{{defunt.inhCendresLieu}}</div>
                            <div class="red--text" v-if="defunt.retrait_cendres!=1">Cendres encore au crématoire</div>
                            <v-divider></v-divider>
                            <div>Contact légal : {{defunt.contacts_designation}}</div>
                            <div>{{defunt.contacts_titre}}<span> {{defunt.contacts_prenom}}</span><span> {{defunt.contacts_nom}}</span></div>
                            <div>{{defunt.contacts_adresse}}<span> {{defunt.contacts_loc}}</span></div>
                            <div><span>Téléphone :</span><span> {{defunt.contacts_tel1}}</span><span v-if="defunt.contacts_tel2!=null && defunt.contacts_tel2!=''"> Téléphone 2 :</span><span> {{defunt.contacts_tel2}}</span></div>
                            <div><span>E-mail :</span><span> {{defunt.contacts_mail1}}</span><span> {{defunt.contacts_mail2}}</span></div>
                            <div v-if="defunt.contacts_remarque!=null && defunt.contacts_remarque!=''"><span>Remarque :</span><span> {{defunt.contacts_remarque}}</span></div>
                        </v-flex>
                        <v-flex xs2>
                            <v-img :src="'./src/getPics.php?name=' + defunt.photo" height="100px"></v-img>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container>
                    <v-layout row>
                        <v-flex xs12>
                            <v-footer absolute style="z-index:1">
                                <img v-if="defunt.incInh=='incineration'" src="../assets/logoInc.png" alt="symbole incinération" height="40px">
                                <img v-if="defunt.incInh=='inhumation'" src="../assets/logoInh.png" alt="symbole inhumation" height="40px">
                                <img v-if="defunt.incInh=='aquamation'" src="../assets/logoAqua.png" alt="symbole aquamation" height="40px">
                                <v-spacer></v-spacer>
                                 <v-tooltip v-if="defunt.remarque!=''" bottom>
                                    <template v-slot:activator="{on, attrs}">
                                        <v-btn v-on="on" v-bind="attrs" @click.stop="showRemarque(defunt.remarque)" text icon dark color="deep-orange"><v-icon>mdi-clipboard-text</v-icon></v-btn>
                                    </template>
                                    <span>{{defunt.remarque}}</span>
                                </v-tooltip>
                                <v-spacer></v-spacer>
                                <v-btn @click.stop.native="defClick('contact', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-account-box</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('services', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-room-service</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('avis', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-text-subject</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('devis', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                                <v-btn @click.stop.native="defClick('check', defunt.id_defunt)" text icon color="indigo">
                                    <v-icon>mdi-check-circle</v-icon>
                                </v-btn>
                            </v-footer>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

</v-flex>
</v-layout>
<v-dialog v-model="dialogRemarque" max-width="500px">
    <v-card>
    <v-card-title>
        <span>Remarque</span>
    </v-card-title>
    <v-card-text>
    {{remarque}}
    </v-card-text>
    <v-card-actions>
        <v-btn color="primary" text @click.stop="dialogRemarque=false">Fermer</v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</div>
</template>
<script>
    import {ajax_post} from '../../public/global.js'
    import currentUser from "../store/currentUser"
    export default {
        data(){
            return{
                loading: false,
                show: false,
                defunts: [],
                dialogRemarque: false,
                remarque: '',
                search: '',
                currentUser: currentUser.user,
                usersList: {},
                userSelected: '',
                switchSearch: true
            }
        },
        methods: {
            fetchData() {
                this.loading = true
                this.recupAllUsers()
                ajax_post(`/PHP/ajax/returnCendres.php`,`token=${this.$token()}`).then((response) =>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        let inhCendresLieu = ''
                        let inhCendresQuand
                        rep.data.forEach(elem => {
                            let dateInhCendres = ""
                            elem.heure_inh_cendres ? dateInhCendres = new Date(elem.date_inh_cendres + 'T' + elem.heure_inh_cendres) : dateInhCendres = new Date(elem.date_inh_cendres)
                            
                            if(elem.cendres_famille==1){
                                inhCendresLieu = ''
                                inhCendresQuand= 'Cendres confiés à la famille'
                                if(elem.date_inh_cendres==null){
                                    inhCendresQuand = 'Cendres confiés à la famille le ???'
                                }else{
                                    if(elem.heure_inh_cendres==null){
                                        inhCendresQuand = 'Cendres confiés à la famille le ' + dateInhCendres.toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ???'
                                    }else{
                                        inhCendresQuand = 'Cendres confiés à la famille le ' + dateInhCendres.toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ' + elem.heure_inh_cendres.substring(5,0).replace(':','h')
                                    }
                                }
                            }else{
                                inhCendresLieu = (elem.lieu_inh_cendres=='' ? "Lieu d'inhumation des cendres pas défini" : (elem.lieu_inh_cendres + ' ' + elem.inhumation_lieu))
                                if(elem.date_inh_cendres==null){
                                    inhCendresQuand = 'Inhumation des cendres le ???'
                                }else{
                                    if(elem.heure_inh_cendres==null){
                                        inhCendresQuand = 'Inhumation des cendres le ' + dateInhCendres.toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ???'
                                    }else{
                                        inhCendresQuand = 'Inhumation des cendres le ' + dateInhCendres.toLocaleDateString('fr-CH', {weekday: "long", month: "short", day: "numeric"}) + ' à ' + elem.heure_inh_cendres.substring(5,0).replace(':','h')
                                    }
                                }
                            }
                            

                            this.defunts.push({id_defunt: elem.id, num: elem.num, sexe: elem.sexe, nom: elem.nom, prenom: elem.prenom, titre: elem.titre, photo: elem.photo, remarque: elem.remarque, inhCendresQuand: inhCendresQuand, inhCendresLieu: inhCendresLieu, contacts_nom: elem.contact_nom, contacts_prenom: elem.contact_prenom, contacts_titre: elem.contact_titre, contacts_designation: elem.contact_designation, contacts_adresse: elem.contact_adresse, contacts_loc: elem.contact_loc, contacts_tel1: elem.contact_tel1, contacts_tel2: elem.contact_tel2, contacts_mail1: elem.contact_mail1, contacts_mail2: elem.contact_mail2, contacts_remarque: elem.contact_remarque, retrait_cendres: elem.retrait_cendres, lieu_inh_cendres: elem.lieu_inh_cendres, cendres_lieu: inhCendresLieu, createdByName: elem.name})
                        })
                        this.loading = false
                    }else{
                        this.loading = false
                        this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })

                
            },
            defSelected(id){
                this.$router.push({name: 'defuntInfo', params: {id: id}})
            },
            defClick(choice, id){
                if(choice=='contact'){
                    this.$router.push({name: 'contact', params: {id: id}})
                }
                if(choice=='services'){
                    this.$router.push({name: 'servicesFunebres', params: {id: id}})
                }
                if(choice=='avis'){
                    this.$router.push({name: 'avisMortuaire', params: {id: id}})
                }
                if(choice=='devis'){
                    this.$router.push({name: 'devis', params: {id: id}})
                }
                if(choice=='check'){
                    this.$router.push({name: 'recap', params: {id: id}})
                }
            },
            showRemarque(remarque){

                this.dialogRemarque = true
                this.remarque = remarque
            },
            recupAllUsers(){
                ajax_post(`/PHP/ajax/returnAllUsers.php`, `token=${this.$token()}`).then((response)=>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                      this.usersList = rep.data
                    }else{
                      this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            }
        },
        computed: {
            defuntsFilter() {
                let self = this
                if(self.switchSearch){
                    return this.defunts.filter(elem => elem.nom.toLowerCase().indexOf(self.search) > -1)
                }else{
                    return this.defunts.filter(elem => elem.createdByName.indexOf(self.userSelected) > -1)
                }
            }
        },
        created() {
            this.fetchData()
        },
        watch: {
            '$route': 'fetchData'
        }
    }
</script>